<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<form nz-form class="form" nzLayout="vertical">
  <div class="drawer-form-wrapper without-bottom-cta">
    <nz-tabset
      [nzTabBarExtraContent]="extraTemplate"
      [(nzSelectedIndex)]="selectedTabIndex">
      <nz-tab nzTitle="Users">
        <app-user-list
          *ngIf="selectedTabIndex === 0"
          [isExportUsers]="isExportUsers"
          (userExported)="isExportUsers = false"></app-user-list>
      </nz-tab>
      <nz-tab nzTitle="Subscriptions"
        ><app-subscription-listing *ngIf="selectedTabIndex === 1"
      /></nz-tab>
      <nz-tab nzTitle="Insights"
        ><app-insights *ngIf="selectedTabIndex === 2"
      /></nz-tab>
      <nz-tab nzTitle="Reference Materials"
        ><app-custom-resources *ngIf="selectedTabIndex === 3"
      /></nz-tab>
      <nz-tab nzTitle="Settings"
        ><app-settings *ngIf="selectedTabIndex === 4"
      /></nz-tab>
    </nz-tabset>
  </div>
</form>

<!-- tabs-cta -->
<ng-template #extraTemplate>
  <div class="cta-wrapper" *ngIf="selectedTabIndex !== 1">
    <nz-input-group
      [nzPrefix]="suffixIconSearch"
      [nzSuffix]="inputClearTpl"
      *ngIf="selectedTabIndex === 0 || selectedTabIndex === 2">
      <input
        type="text"
        nz-input
        placeholder="Search"
        [(ngModel)]="searchTerm"
        (input)="onSearch()" />
      <ng-template #inputClearTpl>
        @if (searchTerm) {
          <span
            nz-icon
            class="ant-input-clear-icon"
            nzTheme="fill"
            nzType="close-circle"
            (click)="searchTerm = ''; onSearch()"></span>
        }
      </ng-template>
    </nz-input-group>
    <button
      *ngIf="selectedTabIndex === 0"
      nz-button
      type="button"
      nzType="default"
      [nzLoading]="isExportUsers"
      [disabled]="isExportUsers"
      (click)="isExportUsers = true">
      Export Users
    </button>
    <button
      *ngIf="selectedTabIndex === 0"
      type="button"
      nz-button
      [nzType]="'primary'"
      class="btn"
      (click)="openAddUserDrawer()">
      Add User
    </button>
    <div class="dropdown" *ngIf="selectedTabIndex === 3">
      <!-- <button
        nz-button
        nz-dropdown
        [nzDropdownMenu]="menu"
        nzTrigger="click"
        [nzPlacement]="'bottomLeft'"
        nzType="default">
        <svg-icon
          src="/assets/icon/icon-manage.svg"
          class="icon s-16"></svg-icon>
        Manage
      </button> -->
      <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu>
          <li nz-menu-item nzClickHide="false" class="action-list-item">
            <svg-icon
              src="/assets/icon/icon-share.svg"
              class="icon s-16 fw-500"></svg-icon>
            <button
              type="button"
              nz-button
              [nzType]="'text'"
              class="btn text s-14 dropdown-btn"
              (click)="openTransferDrawer()">
              Transfer Selected
            </button>
          </li>
          <li nz-menu-item nzClickHide="false" class="action-list-item">
            <svg-icon
              src="/assets/icon/icon-trash.svg"
              class="icon s-16 fw-500"></svg-icon>
            <button
              type="button"
              nz-button
              [nzType]="'text'"
              class="btn text s-14 dropdown-btn">
              Delete Selected
            </button>
          </li>
        </ul>
      </nz-dropdown-menu>
    </div>

    <ng-template #suffixIconSearch>
      <span nz-icon nzType="search"></span>
    </ng-template>
  </div>
  <div class="cta-wrapper" *ngIf="selectedTabIndex === 1">
    <button
      nz-button
      type="button"
      [nzType]="'primary'"
      nzType="default"
      (click)="addNewSubscription()">
      New Subscription
    </button>
  </div>
</ng-template>
<!-- Transfer Drawer -->
<nz-drawer
  [nzClosable]="true"
  [nzVisible]="transferDrawerVisible"
  nzTitle="Import Data File"
  nzPlacement="right"
  (nzOnClose)="closeTansferDrawer()"
  [nzFooter]="importFooterTpl"
  [nzWidth]="520">
  <ng-container *nzDrawerContent>
    <form nz-form class="form" nzLayout="horizontal">
      <div class="drawer-form-wrapper">
        <nz-form-item>
          <nz-form-label nzFor="transferto">Tansfer to</nz-form-label>
          <nz-form-control nzErrorTip="Please select option">
            <nz-select
              nzSuffixIcon
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select a person"
              [(ngModel)]="selectedValue"
              name="transferto"
              [nzOptionOverflowSize]="7">
              <nz-option
                nzLabel="Amanda Denning (denninga@husd4.org)"
                nzValue="Amanda"></nz-option>
              <nz-option
                nzLabel="Blythe Adreon (badreon@insightstobehavior.com)"
                nzValue="Blythe"></nz-option>
              <nz-option
                nzLabel="Brooklyn Webber (bwebber@ccboe.us)"
                nzValue="Brooklyn"></nz-option>
              <nz-option
                nzLabel="Caryn Watts (cwatts.ww@ccboe.us)"
                nzValue="Caryn"></nz-option>
              <nz-option
                nzLabel="Chad MagersTest (cmagers@insightstobehavior.com)"
                nzValue="chad"></nz-option>
              <nz-option
                nzLabel="Clark kent (ckent@superman.com)"
                nzValue="Clark"></nz-option>
              <nz-option
                nzLabel="David Forbush (david.forbush@usu.edu)"
                nzValue="David"></nz-option>
              <nz-option
                nzLabel="Daymi Trowbridge (dtrowbridge@chicousd.org)"
                nzValue="Daymi"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </form>
  </ng-container>
  <ng-template #importFooterTpl>
    <div class="display-flex justify-content-between drawer-footer">
      <button nz-button nzType="default" (click)="closeTansferDrawer()">
        Cancel
      </button>
      <button nz-button nzType="primary" (click)="closeTansferDrawer()">
        Import File
      </button>
    </div>
  </ng-template>
</nz-drawer>
<!-- Transfer Drawer -->
